<template>
    <v-card>
        <v-card-text>
            <h1 style="text-align: center; width: 100%;">{{titulo}}</h1>
        </v-card-text>
        <v-card-actions class="justify-space-around pa-3">
            <v-btn round @click="$emit('nao')">Não</v-btn>
            <v-btn round @click="$emit('sim')" color="error">Sim</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    props: ['titulo']
}
</script>
